import { cn } from "@/lib/utils";
import { Card, CardContent } from "./ui/card";
import {
  Users,
  FileText,
  AlertTriangle,
  Send,
  Euro,
  CheckCircle2,
} from "lucide-react";

function KpiCard({ icon: Icon, iconClass, title, value, sub, valueClass, loading }) {
  return (
    <Card className="card-base border-slate-200/80 shadow-sm">
      <CardContent className="p-4 flex gap-3">
        <div className={cn("w-10 h-10 rounded-xl flex items-center justify-center shrink-0", iconClass)}>
          <Icon className="w-5 h-5" />
        </div>
        <div className="min-w-0">
          <p className="text-xs font-medium text-slate-600">{title}</p>
          <p className={cn("text-xl font-bold mt-0.5 tabular-nums", valueClass || "text-slate-900")}>
            {loading ? "…" : value}
          </p>
          {sub && !loading && <p className="text-xs text-slate-500 mt-0.5">{sub}</p>}
        </div>
      </CardContent>
    </Card>
  );
}

export default function FatturazioneKpiRow({ kpis, formatEuro }) {
  const {
    ospitiDaFatturare,
    fattureGenerate,
    daVerificare,
    fattureInviate,
    totalePrevisto,
    totaleFatturato,
    loading,
  } = kpis;

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3">
      <KpiCard
        icon={Users}
        iconClass="bg-emerald-100 text-emerald-700"
        title="Ospiti da fatturare"
        value={ospitiDaFatturare}
        loading={loading}
      />
      <KpiCard
        icon={FileText}
        iconClass="bg-blue-100 text-blue-700"
        title="Fatture generate"
        value={fattureGenerate}
        loading={loading}
      />
      <KpiCard
        icon={AlertTriangle}
        iconClass="bg-amber-100 text-amber-700"
        title="Da verificare"
        value={daVerificare}
        valueClass="text-amber-800"
        loading={loading}
      />
      <KpiCard
        icon={Send}
        iconClass="bg-violet-100 text-violet-700"
        title="Fatture inviate"
        value={fattureInviate}
        loading={loading}
      />
      <KpiCard
        icon={Euro}
        iconClass="bg-sky-100 text-sky-700"
        title="Totale previsto mese"
        value={formatEuro(totalePrevisto)}
        loading={loading}
      />
      <KpiCard
        icon={CheckCircle2}
        iconClass="bg-emerald-100 text-emerald-700"
        title="Totale fatturato"
        value={formatEuro(totaleFatturato)}
        valueClass="text-emerald-700"
        loading={loading}
      />
    </div>
  );
}

export function OrigineImportiBadge({ origine }) {
  const cfg = {
    automatica: { label: "Automatica", dot: "bg-emerald-500", className: "bg-emerald-50 text-emerald-800" },
    modificata: { label: "Modificata", dot: "bg-amber-500", className: "bg-amber-50 text-amber-900" },
    manuale: { label: "Manuale", dot: "bg-red-500", className: "bg-red-50 text-red-800" },
  };
  const c = cfg[origine] || cfg.automatica;
  return (
    <span className={cn("inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium", c.className)}>
      <span className={cn("w-2 h-2 rounded-full shrink-0", c.dot)} />
      {c.label}
    </span>
  );
}
